import { Route } from "react-router-dom";

import { queryClient } from "@/providers/QueryClient";

import { Action } from "./Action";
import { ActionHub } from "./ActionHub";
import { ActionsTabs } from "./ActionsTabs";
import { CreateAction } from "./CreateAction";
import { InvokeAction } from "./InvokeAction";

export const ActionsRoutes = () => [
  <Route key={"index"} index element={<ActionsTabs />} />,
  <Route key={"create"} path="create" element={<CreateAction />} />,
  <Route
    key={"invoke"}
    path="invoke"
    element={<InvokeAction.Component />}
    loader={InvokeAction.loader(queryClient)}
  />,
  <Route key={"hub"} path="hub" element={<ActionHub />} />,
  <Route key={"actionRef"} path=":actionRef/*" element={<Action />} />,
];
